// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 关系类型枚举 枚举类
 * 关系类型枚举
 */
export enum EnumRelationshipType {
  /** 未定义 : 未定义 */
  None = 0,
  /** 实体继承 : 实体继承 */
  EntityGeneralization = 1,
  /** 接口继承 : 接口继承 */
  InterfaceGeneralization = 2,
  /** 实现 : 实现 */
  Implement = 4,
  /** 依赖 : 依赖 */
  Dependency = 8,
  /** 关联 : 关联 */
  Association = 16,
  /** 聚合 : 聚合 */
  Aggregation = 32,
  /** 组合 : 组合 */
  Composition = 64,
  /** 交叉关联 : 交叉关联，多对多关联 */
  CrossAssociation = 128,
  /** 组件依赖 : 组件与组件的依赖 */
  ComponentDepend = 256,
  /** 引用交叉关联 : 引用交叉关联 */
  ReferCrossAssociation = 512
}

/**
 * 关系类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumRelationshipTypeMD {
  private static items = [
    new EnumItemMD('None', 0, '未定义', '未定义'),
    new EnumItemMD('EntityGeneralization', 1, '实体继承', '实体继承'),
    new EnumItemMD('InterfaceGeneralization', 2, '接口继承', '接口继承'),
    new EnumItemMD('Implement', 4, '实现', '实现'),
    new EnumItemMD('Dependency', 8, '依赖', '依赖'),
    new EnumItemMD('Association', 16, '关联', '关联'),
    new EnumItemMD('Aggregation', 32, '聚合', '聚合'),
    new EnumItemMD('Composition', 64, '组合', '组合'),
    new EnumItemMD('CrossAssociation', 128, '交叉关联', '交叉关联，多对多关联'),
    new EnumItemMD('ComponentDepend', 256, '组件依赖', '组件与组件的依赖'),
    new EnumItemMD('ReferCrossAssociation', 512, '引用交叉关联', '引用交叉关联')
  ];

  static getItem(enumItem: EnumRelationshipType) {
    return this.items.find(item => item.name === EnumRelationshipType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
